'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWeatherPartlySunny = function TiWeatherPartlySunny(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.2 5l-1.7 5-1.7-5c-0.3-0.9 0.2-1.9 1.1-2.2 1-0.3 2 0.2 2.3 1.1 0.1 0.4 0.1 0.8 0 1.1z m8.9 5.1l-4.7 2.3 2.4-4.7c0.4-0.8 1.4-1.2 2.3-0.8 0.9 0.5 1.2 1.5 0.8 2.4-0.2 0.4-0.5 0.6-0.8 0.8z m2.7 9.9l-5-1.7 5-1.6c1-0.3 1.9 0.2 2.3 1.1 0.3 0.9-0.2 1.9-1.2 2.2-0.3 0.1-0.7 0.1-1.1 0z m-21.5-12.3l2.3 4.7-4.7-2.3c-0.9-0.5-1.2-1.5-0.8-2.4 0.4-0.8 1.5-1.2 2.4-0.8 0.3 0.2 0.6 0.5 0.8 0.8z m15.3 12.9c0.3-0.7 0.4-1.5 0.4-2.3 0-4.1-3.4-7.5-7.5-7.5-2.2 0-4.2 1-5.6 2.6-0.1 0-0.1-0.1-0.2-0.1-3 0-5.6 1.3-7.5 3.4-0.4-0.1-0.8-0.2-1.1 0-1 0.3-1.5 1.3-1.2 2.2 0.1 0.3 0.3 0.5 0.5 0.7-0.5 1.1-0.7 2.4-0.7 3.7 0 0.1 0 0.2 0 0.2-2.9 0.8-5 3.4-5 6.5 0 3.7 3 6.7 6.6 6.7h18.4c4.6 0 8.3-3.8 8.3-8.4 0-3.5-2.2-6.5-5.4-7.7z m-7.1-6.4c2.3 0 4.2 1.8 4.2 4.1 0 0.6-0.2 1.2-0.4 1.7-0.6 0.1-1.2 0.2-1.9 0.3-0.9-2.2-2.7-4-4.9-4.8 0.7-0.8 1.8-1.3 3-1.3z m4.2 19.1h-18.4c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.2-3.3l2.4 0-0.5-2c-0.1-0.5-0.1-0.9-0.1-1.4 0-3.6 3-6.6 6.7-6.6 0 0 0-0.1 0.1-0.1 3.2 0.1 5.8 2.4 6.4 5.5 0 0.1 0 0.2 0.1 0.3 0.2 0.7 0.8 1.2 1.5 1.2 0.2 0 0.4 0 0.5 0 0.5-0.2 1-0.3 1.4-0.3 2.7 0 5 2.3 5 5s-2.3 5-5 5z' })
        )
    );
};

exports.default = TiWeatherPartlySunny;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/weather-partly-sunny.js
// module id = 3831
// module chunks = 0